import { Component, Input } from '@angular/core';
import { FILTER_TYPE, IFilterType } from './notification.interface';

@Component({
  selector: 'no-results',
  templateUrl: 'no-results.component.html',
  styleUrls: ['no-results.component.scss'],
})
export class NoResultsComponent {
  @Input() public filterValue: IFilterType;
  public FILTER_TYPE = FILTER_TYPE;
}
